export const Tab = {
  CROP_SOIL: 'crop-soil',
  FERTILIZER_MANAGEMENT: 'fertilizer-management',
  IRRIGATION_MANAGEMENT: 'irrigation-management'
}

export const TabList = [
  Tab.CROP_SOIL,
  Tab.FERTILIZER_MANAGEMENT,
  Tab.IRRIGATION_MANAGEMENT
]

export default {
  Tab,
  TabList
}
